import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Success = () => {
  const navigate = useNavigate();
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    // Set a timer to redirect to the login page after 5 seconds
    const timer = setTimeout(() => {
      setRedirecting(true); // Set redirecting to true
      navigate('/dashboard');
    }, 5000); // Adjust the duration as needed

    // Cleanup timer on component unmount
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="pt-32 bg-gray-100 h-screen">
      <div className="bg-white p-6 w-96 md:mx-auto">
        <svg viewBox="0 0 24 24" className="text-green-600 w-16 h-16 mx-auto my-6">
          <path
            fill="currentColor"
            d="M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
          ></path>
        </svg>
        <div className="text-center">
          <h3 className="md:text-2xl text-base text-gray-900 font-semibold text-center">
            Payment Done!
          </h3>
          <p className="text-gray-600 my-2">Thank you for completing your secure online payment.</p>
          <p>Have a great day!</p>
          <p className="mt-4 text-green-600 text-md">Please verify your email before logging in.</p>
          <div className="py-10 text-center">
            {/* Disable button if redirecting */}
            <a
              href="/login"
              className={`px-12 bg-indigo-600 hover:bg-indigo-500 text-white font-semibold py-3 ${redirecting ? 'cursor-not-allowed opacity-50' : ''}`}
              onClick={(e) => {
                if (redirecting) e.preventDefault();
              }}
            >
              Login
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Success;
